import {Button, Form} from "react-bootstrap";
import React from "react";
import {Controller, useForm} from "react-hook-form";
import FormGroup from "../components/formGroup";
import MySelect from "../components/form/mySelect";
import {isObject} from "lodash";

function DonneesMemoire(props: { onSubmit: Function, parameters: Object }) {
    const {register, control, handleSubmit, formState, getValues} = useForm();
    const onSubmit = data => props.onSubmit(data);

    return (
        <Form noValidate validated={(formState.isSubmitting || formState.isSubmitted) && !formState.isValid}
              onSubmit={handleSubmit(onSubmit)}>

            <Controller name={"MembrePersonnelID"}
                        value={getValues("MembrePersonnelID") !== undefined ? (isObject(getValues("MembrePersonnelID"))
                            ? getValues("MembrePersonnelID").value
                            : props.parameters.MembrePersonnelID.find(f => f.value === getValues("MembrePersonnelID").value)) : undefined}
                        rules={{required: true}}
                        render={({field}) => <FormGroup
                            {...field}
                            errors={formState.errors.MembrePersonnelID}
                            required={true}
                            label={"Promoteur"}
                            type={MySelect}
                            options={props.parameters.MembrePersonnelID}
                        />}
                        control={control}/>
            <blockquote className="mb-5">
                Si vous n'avez pas trouvé de promoteur, veuillez prendre contact avec
                <a href={"mailto:memoires@ichec.be?subject=[ICHEC Student] Promoteur"}> l'équipe mémoire </a>.
            </blockquote>

            <Controller name={"LangueMemoireID"}
                        value={getValues("LangueMemoireID") !== undefined ? (isObject(getValues("LangueMemoireID"))
                            ? getValues("LangueMemoireID").value
                            : props.parameters.LangueMemoireID.find(f => f.value === getValues("LangueMemoireID").value)) : undefined}
                        rules={{required: true}}
                        render={({field}) => <FormGroup
                            {...field}
                            errors={formState.errors.LangueMemoireID}
                            required={true}
                            label={"Langue de rédaction"}
                            type={MySelect}
                            options={props.parameters.LangueMemoireID}
                        />}
                        control={control}/>

            <Controller name={"SessionID"}
                        value={getValues("SessionID") !== undefined ? (isObject(getValues("SessionID"))
                            ? getValues("SessionID").value
                            : props.parameters.SessionID.find(f => f.value === getValues("SessionID").value)) : undefined}
                        rules={{required: true}}
                        render={({field}) => <FormGroup
                            {...field}
                            errors={formState.errors.SessionID}
                            required={true}
                            label={"Première session de défense"}
                            type={MySelect}
                            options={props.parameters.SessionID}
                        />}
                        control={control}/>

            <FormGroup label={"Titre provisoire du mémoire"}
                       as={"textarea"}
                       required={true}
                       {...register("MemoireTitre", {required: true, maxLength: 1000})}
            />

            <Button type="submit" variant="success" size={"lg"} block>
                Sauvegarder
            </Button>
        </Form>
    );
}

export default DonneesMemoire;